<template>
  <div class="container-fluid">
    <!-- Container-fluid starts-->
    <div class="row">
      <div class="col-6">
        <widgetBauprojekte />
        <div class="row">
          <div class="col-6">
            <widgetKunden />
          </div>
          <div class="col-6">
            <widgetDienstleister />
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <div class="col-6">
            <calendar />
          </div>
          <div class="col-6">
            <widgetClock />
          </div>
        </div>
        <!--<Ansprechpartner show_themen="Bau"/>-->
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import widgetBauprojekte from "@/widget/admin/Bauprojekte.vue";
import widgetKunden from "@/widget/admin/Kunden.vue";
import widgetDienstleister from "@/widget/admin/Dienstleister.vue";
import widgetClock from "@/widget/clock.vue";
import calendar from "@/widget/calendar.vue";
import Ansprechpartner from "@/widget/Ansprechpartner.vue";

export default {
  name: "AdminDashboard",
  components: {
    widgetBauprojekte,
    widgetKunden,
    widgetDienstleister,
    widgetClock,
    calendar,
    Ansprechpartner,    
  },
};
</script>
